module.exports = __webpack_public_path__ + "img/PTDX26.690322c9.webp";